module.exports = __webpack_public_path__ + "static/media/img_p5.20c0b419.jpg";